module.exports = __webpack_public_path__ + "static/media/galdisa_acerca_de_tiempo_2017.c01bb66b.jpg";